import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {getComplaints,postComplaints,getComplaintsbyId,deleteComplaints,resolveComplaints,closeComplaints,rejectComplaints,editComplaints,exportComplaints,getComplaintChannel,getComplaintStatus,getComplaintType,
  postInvestigationMessage,getComplaintInvestigation,downloadInvestigationProof
} from "../../services/Complaints/Complaints_services";
const initialValues = {
  complaintChannelList: [],
  complaintStatusList: [],
  complaintList: [],
};
let complaintStore = (set) => ({
  ...initialValues,
  getComplaints: async (params) => {
    const response = await getComplaints(params);
    return response;
  },
  postComplaints: async (data) => {
    const response = await postComplaints(data);
    return response;
  },
  getComplaintsbyId: async (params) => {
    const response = await getComplaintsbyId(params);
    return response;
  },
  deleteComplaints: async (params) => {
    const response = await deleteComplaints(params);
    return response;
  },
  resolveComplaints: async (params) => {
    const response = await resolveComplaints(params);
    return response;
  },
  closeComplaints: async (params) => {
    const response = await closeComplaints(params);
    return response;
  },
    rejectComplaints: async (params) => {
    const response = await rejectComplaints(params);
    return response;
  },
   exportComplaints: async (params) => {
    const response = await exportComplaints(params);
    return response;
  },
  editComplaints: async (params) => {
    const response = await editComplaints(params);
    return response;
  },
  getComplaintChannel: async (params) => {
    const response = await getComplaintChannel(params);
    set({ complaintChannelList: response });
    return response;
  },
  getComplaintStatus: async (params) => {
    const response = await getComplaintStatus(params);
    set({ complaintStatusList: response });
    return response;
  },
  getComplaintType: async (params) => {
    const response = await getComplaintType(params);
    set({ complaintList: response });
    return response;
  },
  postInvestigationMessage: async (params) => {
    const response = await postInvestigationMessage(params);
    return response;
  },
  getComplaintInvestigation: async (params) => {
    const response = await getComplaintInvestigation(params);
    return response;
  },
  downloadInvestigationProof: async (params) => {
    const response = await downloadInvestigationProof(params);
    return response;
  },
});

complaintStore = devtools(complaintStore);

export const useComplaintStore = create(complaintStore);
